var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Box from '@digitools/honest-react/dist/lib/components/Box';
import { Collapse, Icon, themes, Link, Heading, Button } from '@digitools/honest-react';
import useAuthentication from '../../../../hooks/useAuthentication';
import useTealium from '../../../../hooks/useTealium';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';
var StyledSlideoutContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  width: 100vw;\n  height: calc(100vh - 4rem);\n  overflow-x: hidden;\n  left: -1rem;\n"], ["\n  position: absolute;\n  width: 100vw;\n  height: calc(100vh - 4rem);\n  overflow-x: hidden;\n  left: -1rem;\n"])));
var StyledCollapseContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: normal;\n  font-size: 0.938rem;\n  color: ", ";\n\n  .label {\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  a {\n    font-size: 0.938rem;\n    font-weight: 500;\n  }\n"], ["\n  font-weight: normal;\n  font-size: 0.938rem;\n  color: ", ";\n\n  .label {\n    font-size: 1rem;\n    font-weight: 500;\n  }\n\n  a {\n    font-size: 0.938rem;\n    font-weight: 500;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.grayDark;
});
var StyledSlideout = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  z-index: 999;\n  display: block;\n  position: absolute;\n  top: 0;\n  background-color: ", ";\n  padding: 1.75rem;\n  max-width: 450px;\n  font-size: 1.125rem;\n  font-weight: 300;\n  color: ", ";\n\n  &[data-open='true'] {\n    right: 0;\n  }\n  &[data-open='false'] {\n    right: -450px;\n  }\n\n  transition: right 0.75s;\n\n  h2 {\n    button {\n      font-size: 1.25rem;\n      font-weight: 400;\n    }\n  }\n"], ["\n  z-index: 999;\n  display: block;\n  position: absolute;\n  top: 0;\n  background-color: ", ";\n  padding: 1.75rem;\n  max-width: 450px;\n  font-size: 1.125rem;\n  font-weight: 300;\n  color: ", ";\n\n  &[data-open='true'] {\n    right: 0;\n  }\n  &[data-open='false'] {\n    right: -450px;\n  }\n\n  transition: right 0.75s;\n\n  h2 {\n    button {\n      font-size: 1.25rem;\n      font-weight: 400;\n    }\n  }\n"])), themes.lincoln.palette.grayLightest, themes.lincoln.palette.gray);
var StyledExitButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 1.5rem;\n  right: 1rem;\n  padding: 0.5rem;\n\n  &:hover,\n  &:active,\n  &:focus {\n    padding: 0.5rem !important;\n  }\n\n  &:active,\n  &:focus {\n    box-shadow: 0 0 0.25rem 0.1rem ", ";\n  }\n\n  i {\n    color: ", " !important;\n  }\n"], ["\n  position: absolute;\n  top: 1.5rem;\n  right: 1rem;\n  padding: 0.5rem;\n\n  &:hover,\n  &:active,\n  &:focus {\n    padding: 0.5rem !important;\n  }\n\n  &:active,\n  &:focus {\n    box-shadow: 0 0 0.25rem 0.1rem ", ";\n  }\n\n  i {\n    color: ", " !important;\n  }\n"])), themes.lincoln.palette.secondary, themes.lincoln.palette.gray);
var StyledHeading = styled(Heading)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 0 !important;\n  margin-bottom: 0.5rem;\n  color: ", " !important;\n"], ["\n  margin-top: 0 !important;\n  margin-bottom: 0.5rem;\n  color: ", " !important;\n"])), themes.lincoln.palette.gray);
var SlideoutContainer = function (_a) {
  var openSlideout = _a.openSlideout,
    isOpen = _a.isOpen;
  var user = useAuthentication().user;
  var slideoutRef = useRef(null);
  var trackEvent = useTealium().trackEvent;
  var claimBenefitInfoOpenRef = useRef();
  var setClaimBenefitInfo = function (isOpen) {
    claimBenefitInfoOpenRef.current = isOpen;
  };
  var headerClickClaimBenefitInfo = function () {
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: 'Claims & benefit information',
      event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT,
      event_status: claimBenefitInfoOpenRef.current ? 'Collapse' : 'Expand'
    });
  };
  var technicalAssistanceOpenRef = useRef();
  var setTechnicalAssistanceOpenRef = function (isOpen) {
    technicalAssistanceOpenRef.current = isOpen;
  };
  var headerClickTechnicalAssistance = function () {
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: 'Technical assistance',
      event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT,
      event_status: technicalAssistanceOpenRef.current ? 'Collapse' : 'Expand'
    });
  };
  var onSliderClose = useCallback(function (openSlideout) {
    openSlideout(false);
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT,
      event_type: TEALIUM_EVENT.EVENT_TYPE.H_LINK,
      event_status: 'Close'
    });
  }, [trackEvent]);
  useEffect(function () {
    var handleEscape = function (e) {
      if (e.key === 'Escape') {
        onSliderClose(openSlideout);
      }
    };
    var handleClick = function (e) {
      if (slideoutRef && slideoutRef.current && (slideoutRef.current.contains(e.target) || slideoutRef.current === e.target)) {
        return;
      }
      onSliderClose(openSlideout);
    };
    if (isOpen) {
      document.addEventListener('mouseup', handleClick);
      document.addEventListener('keyup', handleEscape);
    } else {
      document.removeEventListener('mouseup', handleClick);
      document.removeEventListener('keyup', handleEscape);
    }
    return function () {
      document.removeEventListener('mouseup', handleClick);
      document.removeEventListener('keyup', handleEscape);
    };
  }, [isOpen, openSlideout, onSliderClose]);
  return _jsx(StyledSlideoutContainer, __assign({
    "data-public": true
  }, {
    children: _jsxs(StyledSlideout, __assign({
      "data-open": isOpen,
      "data-testid": 'slideout',
      ref: slideoutRef
    }, {
      children: [_jsx(StyledExitButton, __assign({
        onClick: function () {
          return onSliderClose(openSlideout);
        },
        "data-testid": 'slideout-exit-button'
      }, {
        children: _jsx(Icon, {
          color: 'gray',
          name: 'close',
          "aria-label": 'close contact and support options',
          role: 'button'
        })
      })), _jsx(StyledHeading, __assign({
        elemType: 'h1',
        elemStyle: 'h3'
      }, {
        children: "Contact and support"
      })), _jsx("p", {
        children: "Need help? Our customer support teams are here to assist you."
      }), _jsx(Box, {
        children: _jsx(Collapse, __assign({
          headerElemType: 'h2',
          type: 'alternate',
          title: 'Technical assistance',
          theme: themes.lincoln,
          isOpenRef: setTechnicalAssistanceOpenRef,
          headerClick: headerClickTechnicalAssistance
        }, {
          children: _jsxs(StyledCollapseContent, {
            children: [_jsx("div", __assign({
              className: 'label'
            }, {
              children: "Phone Number"
            })), _jsx(Link, __assign({
              href: 'tel:1-877-321-1014',
              onClick: function () {
                trackEvent({
                  event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                  event_name: 'Technical assistance - Call us',
                  event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT
                });
              }
            }, {
              children: "1-877-321-1014"
            })), _jsx("br", {}), "Monday - Thursday: 8 a.m. to 8 p.m. ET", _jsx("br", {}), "Friday: 8 a.m. to 6 p.m. ET", _jsx("div", __assign({
              className: 'label mt-2'
            }, {
              children: "Email"
            })), _jsx(Link, __assign({
              href: 'mailto:LincolnDentalProviderPortal_support@lfg.com',
              onClick: function () {
                trackEvent({
                  event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                  event_name: 'Technical assistance - Email us',
                  event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT
                });
              }
            }, {
              children: "LincolnDentalProviderPortal_support@lfg.com"
            }))]
          })
        }))
      }), _jsx(Box, {
        children: _jsx(Collapse, __assign({
          headerElemType: 'h2',
          type: 'alternate',
          title: 'Claim & benefit information',
          theme: themes.lincoln,
          isOpenRef: setClaimBenefitInfo,
          headerClick: headerClickClaimBenefitInfo
        }, {
          children: _jsxs(StyledCollapseContent, {
            children: [_jsx("div", __assign({
              className: 'label'
            }, {
              children: "Phone Number"
            })), _jsx(Link, __assign({
              href: 'tel:1-800-423-2765',
              onClick: function () {
                trackEvent({
                  event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                  event_name: 'Claim & benefit information - Call us',
                  event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT
                });
              }
            }, {
              children: "1-800-423-2765"
            })), _jsx("br", {}), "Monday - Thursday: 8 a.m. to 8 p.m. ET", _jsx("br", {}), "Friday: 8 a.m. to 6 p.m. ET", _jsx("div", __assign({
              className: 'label mt-2'
            }, {
              children: "Email"
            })), _jsx(Link, __assign({
              href: 'mailto:Claims@lfg.com',
              onClick: function () {
                trackEvent({
                  event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                  event_name: 'Claims & benefit information - Email us',
                  event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT
                });
              }
            }, {
              children: "Claims@lfg.com"
            }))]
          })
        }))
      }), _jsx(Box, {
        children: _jsx(Collapse, __assign({
          headerElemType: 'h2',
          type: 'alternate',
          title: 'Virtual card payments (EFT)',
          theme: themes.lincoln,
          isOpenRef: setTechnicalAssistanceOpenRef,
          headerClick: headerClickTechnicalAssistance
        }, {
          children: _jsxs(StyledCollapseContent, {
            children: [_jsx("div", {
              children: "For additional information on a virtual card payment you have received, or to opt out of the virtual card payments and receive paper check payments, contact:"
            }), _jsx("div", __assign({
              className: 'label mt-3'
            }, {
              children: "Phone Number: ECHO CPR"
            })), _jsx(Link, __assign({
              href: 'tel:1-888-697-6381',
              onClick: function () {
                trackEvent({
                  event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                  event_name: 'Virtual Card Payments (EFT) - Phone Number',
                  event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT
                });
              }
            }, {
              children: "(888) 697-6381"
            })), _jsx("div", __assign({
              className: 'label mt-2'
            }, {
              children: "Website"
            })), _jsx(Link, __assign({
              href: 'https://providerpayments.com',
              rel: 'noopener',
              target: '_blank',
              onClick: function () {
                trackEvent({
                  event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
                  event_name: 'Virtual Card Payments (EFT) - Website',
                  event_type: TEALIUM_EVENT.EVENT_TYPE.CONTACT_SUPPORT
                });
              }
            }, {
              children: "https://providerpayments.com"
            }))]
          })
        }))
      })]
    }))
  }));
};
export default SlideoutContainer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;